import {
	makeStyles,
	Tab,
	Tabs,
	TextField,
	withStyles,
} from '@material-ui/core';
import React, { useState } from 'react';
import './Client.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { TextFields } from '@material-ui/icons';
import clsx from 'clsx';
import PlacesAutocomplete, {
	geocodeByAddress,
	getLatLng,
} from 'react-places-autocomplete';
import { range } from 'lodash';

function Client({
	setIndividualDetails,
	setCorporationDetails,
	setDisable,
	disable,
	setIsCompleted,
	isCompleted,
}) {
	const [value, setValue] = useState(0);
	const [individualDob, setIndividualDob] = useState(new Date());
	const [businessDob, setBusinessDob] = useState(new Date());

	const [address, setAddress] = useState('');
	const [businessAddress, setBusinessAddress] = useState('');
	const [formData, setFormData] = useState({
		firstName: '',
		lastName: '',
		emailAddress: '',
		phoneNumber: '',
		dlNumber: '',
	});

	const [formDataBusiness, setFormDataBusiness] = useState({
		corporationName: '',
		businessType: '',
		registrationNumber: '',
		directorFName: '',
		directorLName: '',
		businessPhone: '',
	});

	const { firstName, lastName, emailAddress, phoneNumber, dlNumber } = formData;

	const {
		corporationName,
		businessType,
		registrationNumber,
		directorFName,
		directorLName,
		businessPhone,
	} = formDataBusiness;

	const onChange = (e) =>
		setFormData({ ...formData, [e.target.name]: e.target.value });

	const onChangeBusiness = (e) =>
		setFormDataBusiness({
			...formDataBusiness,
			[e.target.name]: e.target.value,
		});

	const handleChange = (event, newValue) => {
		setValue(newValue);

		if (newValue === 0) {
			setCorporationDetails();
			setFormDataBusiness({
				corporationName: '',
				businessType: '',
				businessAddress: '',
				registrationNumber: '',
				directorFName: '',
				directorLName: '',
			});
			setBusinessAddress('');
		} else if (newValue === 1) {
			setIndividualDetails();
			setFormData({
				firstName: '',
				lastName: '',
				emailAddress: '',
				dob: '',
				phoneNumber: '',
				dlNumber: '',
			});
			setAddress('');
		}
	};

	const useStyles = makeStyles((theme) => ({
		root: {
			flexGrow: 1,
			borderRadius: 8,
		},
		clientTab: {
			backgroundColor: '#F1F5F8',
			marginBottom: '1em',
			boxShadow: '0px 1px 8px rgba(20, 46, 110, 0.1)',
			width: '22em',
		},
		form: {
			display: 'flex',
			flexDirection: 'column',
		},
		field: {
			marginBottom: '20px',
			width: '100%',
			margin: '20px',
			'& .MuiInput-underline:after': {
				borderBottomColor: 'blue',
				borderBottom: '2px solid',
			},
		},
		datePicker: {
			height: '36px',
			borderTop: 'none',
			borderLeft: 'none',
			borderRight: 'none',
			outline: 'none',
			borderBottom: '1px solid #949494',
		},
		label: {
			marginBottom: '-2.3em',
			fontSize: '10px',
			color: 'grey',
		},
	}));

	const StyledTabs = withStyles({
		indicator: {
			display: 'flex',
			justifyContent: 'center',
			backgroundColor: 'transparent',
		},
	})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

	const StyledTab = withStyles((theme) => ({
		root: {
			textTransform: 'none',
			color: '#636D73',

			'&.Mui-selected': {
				backgroundColor: '#FFFFFF',
				boxShadow: '0px 1px 8px rgba(20, 46, 110, 0.1)',
				borderRadius: '8px',
				color: '#2662F0',
			},
		},
	}))((props) => <Tab {...props} />);

	const styles = useStyles();

	const handleSave = () => {
		setDisable({ ...disable, client: false });
		if (value === 0) {
			console.log('Sending Individual details');
			if (
				firstName === '' ||
				lastName === '' ||
				phoneNumber === '' ||
				individualDob === '' ||
				dlNumber === '' ||
				address === ''
			) {
				alert('Please fill in all the fields.');
			} else {
				setIndividualDetails({
					firstName: firstName,
					lastName: lastName,
					phoneNumber: phoneNumber,
					email: emailAddress,
					dob: individualDob,
					dlNumber: dlNumber,
					address: address,
				});
			}
		} else if (value === 1) {
			console.log('Sending corporation details');

			setCorporationDetails({
				corporationName: corporationName,
				businessType: businessType,
				registrationNumber: registrationNumber,
				directorFName: directorFName,
				directorLName: directorLName,
				businessPhone: businessPhone,
				dob: businessDob,
				businessAddress: businessAddress,
			});
		}
	};

	const handleSelect = async (value) => {
		const results = await geocodeByAddress(value);
		setAddress(value);
	};

	const handleSelectBusiness = async (value) => {
		const results = await geocodeByAddress(value);
		setBusinessAddress(value);
	};

	const inputProps = (getInputProps) =>
		getInputProps({
			placeholder: 'Address',
		});

	return (
		<div className='doc_card client_wrapper'>
			<div className='card_title'>Who is this agreement for?</div>
			<div className={styles.root}>
				<div className={styles.clientTab}>
					<StyledTabs value={value} onChange={handleChange} centered>
						<StyledTab label={'Invidividual'} />
						<StyledTab label={'Corporation'} />
					</StyledTabs>
				</div>
				{value === 0 ? (
					<div className='client_form'>
						<div className={styles.form}>
							<TextField
								type='text'
								label='First Name'
								name='firstName'
								value={firstName}
								className={styles.field}
								onChange={(e) => onChange(e)}
							/>
							<TextField
								type='text'
								label='Last Name'
								name='lastName'
								value={lastName}
								onChange={(e) => onChange(e)}
								className={styles.field}
							/>
							<TextField
								type='text'
								label='Email Address'
								name='emailAddress'
								value={emailAddress}
								onChange={(e) => onChange(e)}
								className={styles.field}
							/>

							<TextField
								type='tel'
								label='Phone Number'
								className={styles.field}
								pattern='[0-9]{3}[0-9]{3}[0-9]{4}'
								name='phoneNumber'
								value={phoneNumber}
								onChange={(e) => onChange(e)}
							/>

							{/* <TextField
								id='date'
								label='Date of Birth'
								type='date'
								name='dob'
								value={dob}
								onChange={(e) => onChange(e)}
								className={styles.field}
								InputLabelProps={{
									shrink: true,
								}}
							/> */}
							<label className={clsx(styles.field, styles.label)}>
								Date of birth
							</label>
							<DatePicker
								selected={individualDob}
								id='date'
								placeholderText='Date of Birth'
								maxDate={Date.now()}
								onChange={(date) => setIndividualDob(date)}
								className={clsx(styles.field, styles.datePicker)}
								showTimeSelect={false}
							/>

							{/* <DatePicker
						selected={startDate}
						onChange={(date) => setStartDate(date)}
						minDate={Date.now()}
						showTimeSelect
						timeFormat='HH:mm'
						timeIntervals={15}
						timeCaption='time'
						dateFormat='MMMM d, yyyy h:mm aa'
					/> */}

							<TextField
								type='text'
								label='DL Number'
								name='dlNumber'
								value={dlNumber}
								className={styles.field}
								onChange={(e) => onChange(e)}
							/>

							{/* <TextField
								type='text'
								label='Address'
								name='address'
								className={styles.field}
								value={address}
								onChange={(e) => onChange(e)}
							/> */}
							<PlacesAutocomplete
								value={address}
								onChange={setAddress}
								onSelect={handleSelect}
								className={styles.field}
							>
								{({
									getInputProps,
									suggestions,
									getSuggestionItemProps,
									loading,
								}) => (
									<div className={styles.field}>
										<TextField
											style={{ width: '45vw' }}
											{...getInputProps({
												placeholder: 'Address',
												className: 'location-search-input',
											})}
										/>

										<div className='autocomplete-dropdown-container'>
											{loading && <div>Loading...</div>}
											{suggestions.map((suggestion) => {
												const className = suggestion.active
													? 'suggestion-item--active'
													: 'suggestion-item';
												// inline style for demonstration purpose
												const style = suggestion.active
													? { backgroundColor: '#fafafa', cursor: 'pointer' }
													: { backgroundColor: '#ffffff', cursor: 'pointer' };
												return (
													<div
														{...getSuggestionItemProps(suggestion, {
															className,
															style,
														})}
													>
														<span>{suggestion.description}</span>
													</div>
												);
											})}
										</div>
									</div>
								)}
							</PlacesAutocomplete>
							<button
								className='individualBtn btn btn-primary d-block mr-0 ml-auto'
								onClick={() => handleSave()}
							>
								Save
							</button>
						</div>
					</div>
				) : (
					<div className='corporation_form'>
						<div className={styles.form}>
							<TextField
								type='text'
								label='Name of Corporation'
								name='corporationName'
								value={corporationName}
								onChange={(e) => onChangeBusiness(e)}
								className={styles.field}
							/>
							<TextField
								type='text'
								label='Type of Business'
								name='businessType'
								value={businessType}
								className={styles.field}
								onChange={(e) => onChangeBusiness(e)}
							/>
							<PlacesAutocomplete
								value={businessAddress}
								onChange={setBusinessAddress}
								onSelect={handleSelectBusiness}
								className={styles.field}
							>
								{({
									getInputProps,
									suggestions,
									getSuggestionItemProps,
									loading,
								}) => (
									<div className={styles.field}>
										<TextField
											style={{ width: '45vw' }}
											{...getInputProps({
												placeholder: 'Business Address',
												className: 'location-search-input',
											})}
										/>

										<div className='autocomplete-dropdown-container'>
											{loading && <div>Loading...</div>}
											{suggestions.map((suggestion) => {
												const className = suggestion.active
													? 'suggestion-item--active'
													: 'suggestion-item';
												// inline style for demonstration purpose
												const style = suggestion.active
													? { backgroundColor: '#fafafa', cursor: 'pointer' }
													: { backgroundColor: '#ffffff', cursor: 'pointer' };
												return (
													<div
														{...getSuggestionItemProps(suggestion, {
															className,
															style,
														})}
													>
														<span>{suggestion.description}</span>
													</div>
												);
											})}
										</div>
									</div>
								)}
							</PlacesAutocomplete>
							<TextField
								type='number'
								label='Registration Number'
								name='registrationNumber'
								value={registrationNumber}
								className={styles.field}
								onChange={(e) => onChangeBusiness(e)}
							/>
							<TextField
								type='text'
								label='Director First Name'
								name='directorFName'
								value={directorFName}
								onChange={(e) => onChangeBusiness(e)}
								className={styles.field}
							/>
							<TextField
								type='text'
								label='Director Last Name'
								name='directorLName'
								value={directorLName}
								onChange={(e) => onChangeBusiness(e)}
								className={styles.field}
							/>
							<TextField
								type='tel'
								label='Phone Number'
								className={styles.field}
								pattern='[0-9]{3}[0-9]{3}[0-9]{4}'
								name='businessPhone'
								value={businessPhone}
								onChange={(e) => onChangeBusiness(e)}
							/>

							{/* <TextField
								id='date'
								label='Date of Birth'
								type='date'
								name='dob'
								value={dob}
								onChange={(e) => onChangeBusiness(e)}
								className={styles.field}
								InputLabelProps={{
									shrink: true,
								}}
							/> */}
							<label className={clsx(styles.field, styles.label)}>
								Date of birth
							</label>
							<DatePicker
								selected={businessDob}
								id='date'
								placeholderText='Date of Birth'
								maxDate={Date.now()}
								onChange={(date) => setBusinessDob(date)}
								className={clsx(styles.field, styles.datePicker)}
								showTimeSelect={false}
							/>

							<button
								className='corporationBtn btn btn-primary d-block mr-0 ml-auto'
								onClick={() => handleSave()}
							>
								Save
							</button>
						</div>
					</div>
				)}
			</div>
		</div>
	);
}

export default Client;
